import { Component, Input, AfterViewInit, ContentChildren, QueryList, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ExpressionOptionDropdownOptionComponent } from './expression-option-dropdown-option.component';
import { FieldTypeEnum } from '../../search-expression/field-type.enum';

@Component({
  selector: 'wl-expression-option',
  template: '',
    standalone: false
})
export class ExpressionOptionComponent {
  @Input('displayName') public name: string;
  @Input('fieldName') public value: string;
  @Input('fieldType') public fieldType: FieldTypeEnum;

  /**
   * for boolean value types
   */
  @Input() public trueLabel: string = '';

  /**
   * for boolean value types
   */
  @Input() public falseLabel: string = '';

  @ContentChildren(ExpressionOptionDropdownOptionComponent) public dropdownOptions: QueryList<ExpressionOptionDropdownOptionComponent>;

  public constructor() {
    this.fieldType = FieldTypeEnum.String;
  }
}
